
import axios from 'axios'
import { Toast } from 'vant'

/** 
 * 提示函数  需要安装vant
 * @param {String} tip [提示信息]
 */
const tip = msg => {
    Toast({
        message: msg,
        duration: 1000,
        forbidClick: true
    });
}
/** 
 * 请求失败后的错误统一处理 
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        //其他状态码

        // 404请求不存在
        case 404:
            tip('请求的资源不存在');
            break;
        default:
            console.log(other);
    }
}

// 创建axios实列
let instance = axios.create({ timeout: 1000*12 })
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


// 响应拦截器
instance.interceptors.response.use(
    // 请求成功
    res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
    // 请求失败
    error => {
        const { response } = error;
        if (response) {
            // 请求已发出，但是不在2xx的范围 
            errorHandle(response.status, response.data.message);
            return Promise.reject(response);
        }
        //断网的情况下
    });

export default instance;

// // 生产环境和开发环境的接口地址
// if (process.env.NODE_ENV == 'development') {
//     axios.defaults.baseURL = 'http://106.15.170.130/dnf/';
// }
// else if (process.env.NODE_ENV == 'production') {
//     axios.defaults.baseURL = 'http://106.15.170.130/dnf/';
// }

// // 设置超时 10s
// axios.defaults.timeout = 10000;
// // post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// // 响应拦截
// // 响应拦截器
// axios.interceptors.response.use(
//     response => {
//         // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
//         // 否则的话抛出错误
//         if (response.status === 200) {
//             return Promise.resolve(response);
//         } else {
//             return Promise.reject(response);
//         }
//     },
//     // 服务器状态码不是2开头的的情况
//     // 这里可以跟你们的后台开发人员协商好统一的错误状态码    
//     // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
//     // 下面列举几个常见的操作，其他需求可自行扩展
//     error => {
//         if (error.response.status) {
//             switch (error.response.status) {
//                 // 401: 未登录
//                 // 未登录则跳转登录页面，并携带当前页面的路径
//                 // 在登录成功后返回当前页面，这一步需要在登录页操作。                
//                 // 403 token过期
//                 // 登录过期对用户进行提示
//                 // 清除本地token和清空vuex中token对象
//                 // 跳转登录页面                

//                 // 404请求不存在
//                 case 404:
//                     Toast({
//                         message: '网络请求不存在',
//                         duration: 1500,
//                         forbidClick: true
//                     });
//                     break;
//                 // 其他错误，直接抛出错误提示
//                 default:
//                     Toast({
//                         message: error.response.data.message,
//                         duration: 1500,
//                         forbidClick: true
//                     });
//             }
//             return Promise.reject(error.response);
//         }
//     }
// );

// /**
//  * get方法，对应get请求
//  * @param {String} url [请求的url地址]
//  * @param {Object} params [请求时携带的参数]
//  */
// export function get(url, params = null) {
//     return new Promise((resolve, reject) => {
//         axios({
            // withCredentials: true,
            // crossDomain: true,
            // method: "get",
            // url,
            // params
//         }).then(res => {
//             resolve(res.data)
//         }).catch(err => {
//             reject(err.data)
//         })
//     })
// }

// export function post(url, data) {
//     return new Promise((resolve, reject) => {
//         axios({
//             withCredentials: true,
//             crossDomain: true,
//             method: "post",
//             url,
//             data: qs.stringify(data)
//         }).then(res => {
//             resolve(res.data)
//         }).catch(err => {
//             reject(err.data)
//         })
//     })
// }